import { render, staticRenderFns } from "./VenueSetupTabs.vue?vue&type=template&id=6dddc54a&"
import script from "./VenueSetupTabs.vue?vue&type=script&lang=js&"
export * from "./VenueSetupTabs.vue?vue&type=script&lang=js&"
import style0 from "./VenueSetupTabs.vue?vue&type=style&index=0&id=6dddc54a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports